import { Navigate } from 'react-router-dom';
import { usePortalStore } from '@/stores/portal.store';

export function PortalProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = usePortalStore();

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />;
  }

  return <>{children}</>;
}
